import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=04b1a3b2&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=04b1a3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1a3b2",
  null
  
)

export default component.exports